import axios from "axios";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";
import * as Yup from 'yup';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom'
import React, { useState, useRef, useEffect } from "react";
import { IoMdClose } from "react-icons/io";
import { RotatingLines } from 'react-loader-spinner'

const Home = () => {
  const [loading, setLoading] = useState(false);
  const [email,setEmail]=useState('')
  const [showPopUpVerify,setShowPopupVerify]=useState(false)
  const [viewPassword, setViewPassword] = useState(false);
  const navigate = useNavigate();
  const initialValues = {
    email: '',
    password: '',
  };

  const validationSchema = Yup.object({
    email: Yup.string().email('Invalid email format').required('Email is required'),
    password: Yup.string()
    .min(8, 'Password must be at least 8 characters long')
    .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
    .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
    .matches(/[0-9]/, 'Password must contain at least one number')
    .matches(/[!@#$%^&*(),.?":{}|<>]/, 'Password must contain at least one special character')
    .required('Password is required'),
  });

  const Popup = ({ emailId, onCancel }) => {
    const [reSend, setResend] = useState(false);
    const [loadingSend, setLoadingSend] = useState(false);
    const [timer, setTimer] = useState(120);
    const navigate = useNavigate();
  
    const validationSchema = Yup.object().shape({
      email: Yup.string().email('Invalid email format').required('Email is required'),
      otp1: Yup.string().required('OTP is required'),
      otp2: Yup.string().required('OTP is required'),
      otp3: Yup.string().required('OTP is required'),
      otp4: Yup.string().required('OTP is required'),
    });
  
    const inputRefs = {
      otp1: useRef(null),
      otp2: useRef(null),
      otp3: useRef(null),
      otp4: useRef(null),
    };
  
    useEffect(() => {
      const countdown = setInterval(() => {
        setTimer((prevTimer) => (prevTimer > 0 ? prevTimer - 1 : 0));
      }, 1000);
  
      return () => clearInterval(countdown);
    }, []);
  
    const focusNextInput = (fieldName) => {
      switch (fieldName) {
        case "otp1":
          inputRefs.otp2.current.focus();
          break;
        case "otp2":
          inputRefs.otp3.current.focus();
          break;
        case "otp3":
          inputRefs.otp4.current.focus();
          break;
        default:
          break;
      }
    };
  
    const focusPrevInput = (fieldName) => {
      switch (fieldName) {
        case "otp2":
          inputRefs.otp1.current.focus();
          break;
        case "otp3":
          inputRefs.otp2.current.focus();
          break;
        case "otp4":
          inputRefs.otp3.current.focus();
          break;
        default:
          break;
      }
    };

    const handlePaste = (e, setFieldValue) => {
      const pasteData = e.clipboardData.getData('text');
      if (pasteData.length === 4) {
        const otpFields = ['otp1', 'otp2', 'otp3', 'otp4'];
        otpFields.forEach((field, index) => {
          setFieldValue(field, pasteData[index]);
        });
      }
      e.preventDefault();
    };
  
    const onSendVerifyOtp = async (values) => {
      try {
        setLoadingSend(true);
        const response = await axios.post(
          "https://bankdata.inclineanalytics.com/api/users/verify-login-otp",
          values
        );
        if (response.data.success) {
          toast.success(response.data.message);
          localStorage.setItem("role", response.data.data.userRole);
          Cookies.set('jwt_token', response.data.data.token, { expires: 30, secure: true });
          const id = response.data.data.id
          setTimeout(() => {
            navigate('/user',{ state: { id} });
            setLoadingSend(false);
          }, 2000);
        }
      } catch (error) {
        console.error("Error verifying email:", error);
        toast.error(error.response.data.message);
        setLoadingSend(false);
      }
    };
  
    const reSendOtp = async (value) => {
      try {
        setResend(true);
        const data = {
          email: value
        };
        const response = await axios.post(
          "https://bankdata.inclineanalytics.com/api/users/resend_otp",
          data
        );
        if (response.data.success) {
          toast.success(response.data.message);
        }
      } catch (error) {
        console.error("Error re-send otp:", error);
        toast.error(error.response.data.message);
      } finally {
        setResend(false);
        setTimer(120);
      }
    };
  
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50">
        <div className="bg-white p-8 pt-4 rounded shadow-lg w-[400px] overflow-y-auto">
          <div className="flex justify-end">
            <button className="text-black py-2 text-[25px] px-4 font-medium rounded" onClick={onCancel}>
              <IoMdClose />
            </button>
          </div>
          <Formik
            initialValues={{ email: emailId, otp1: "", otp2: "", otp3: "", otp4: "" }}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              const data = {
                email: values.email,
                otp: `${values.otp1}${values.otp2}${values.otp3}${values.otp4}`,
              };
              onSendVerifyOtp(data);
            }}
          >
            {({ values, errors, touched, setFieldValue }) => (
              <Form className="">
                <p className="mb-4 text-3xl text-[#ff6f61] font-bold">Verify Email</p>
                <div className="flex flex-col mb-3">
                  <label htmlFor="email" className="self-start text-gray-700 text-lg font-bold mb-2">
                    Email:
                  </label>
                  <Field type="email" readOnly name="email" className="mt-1 block w-full p-2 pl-4 border rounded-lg text-black border-[#ff6f61] focus:border-[#ff6f61] focus:border-[3px] focus:outline-none" />
                  <div className="flex self-start">
                    <ErrorMessage name="email" component="div" className="text-red-500 " />
                  </div>
                </div>
                <p className="text-black mb-2 mt-2 text-left italic">Successfully sent OTP to the registered email.</p>
                <div className="flex justify-end items-center space-x-2">
                {reSend &&                                
                    <div className="mt-2 mr-2"><RotatingLines
                      strokeColor="#ff6f61"
                      strokeWidth="5"
                      animationDuration="0.75"
                      width="20"
                      visible={true}
                  /></div>}
                  <button onClick={() => {                    
                      reSendOtp(values.email)                    
                  }} type="button" className={`text-gray-600 mt-2 ${timer===0 && "text-gray-400 hover:underline"}`} disabled={timer > 0}>Re-send OTP</button>
                  {timer > 0 && <span className="text-gray-500 mt-2">({Math.floor(timer / 60)}:{(timer % 60).toString().padStart(2, '0')})</span>}
                </div>
                <div className="flex justify-center items-center w-full">                        
                    <div className="mb-4 h-[100px] min-w-[200px] p-4 flex flex-col items-center justify-center lg:flex lg:justify-between lg:items-center">
                      <label htmlFor="otp" className="block text-left w-full text-gray-700 text-lg font-bold mb-2">
                        OTP
                      </label>
                      <div className="flex gap-2">
                        <Field
                          type="text"
                          id="otp1"
                          name="otp1"
                          maxLength="1"
                          className="w-12 h-12 text-center text-black border border-[#ff6f61] rounded-lg focus:outline-none focus:border-[#ff6f61] focus:border-[3px]"
                          innerRef={inputRefs.otp1}
                          onPaste={(e) => handlePaste(e, setFieldValue)}
                          onKeyUp={(e) => {
                            if (e.key === "Backspace") {
                              focusPrevInput("otp1");
                            } else if (e.target.value.length === 1) {
                              focusNextInput("otp1");
                            }
                          }}
                        /> 
                        <Field
                          type="text"
                          id="otp2"
                          name="otp2"
                          maxLength="1"
                          className="w-12 h-12 text-center text-black border border-[#ff6f61] rounded-lg focus:outline-none focus:border-[#ff6f61] focus:border-[3px]"
                          innerRef={inputRefs.otp2}
                          onKeyUp={(e) => {
                            if (e.key === "Backspace") {
                              focusPrevInput("otp2");
                            } else if (e.target.value.length === 1) {
                              focusNextInput("otp2");
                            }
                          }}
                        />
                        <Field
                          type="text"
                          id="otp3"
                          name="otp3"
                          maxLength="1"
                          className="w-12 h-12 text-center text-black border border-[#ff6f61] rounded-lg focus:outline-none focus:border-[#ff6f61] focus:border-[3px]"
                          innerRef={inputRefs.otp3}
                          onKeyUp={(e) => {
                            if (e.key === "Backspace") {
                              focusPrevInput("otp3");
                            } else if (e.target.value.length === 1) {
                              focusNextInput("otp3");
                            }
                          }}
                        />
                        <Field
                          type="text"
                          id="otp4"
                          name="otp4"
                          maxLength="1"
                          className="w-12 h-12 text-center text-black border border-[#ff6f61] rounded-lg focus:outline-none focus:border-[#ff6f61] focus:border-[3px]"
                          innerRef={inputRefs.otp4}
                          onKeyUp={(e) => {
                            if (e.key === "Backspace") {
                              focusPrevInput("otp4");
                            } else if (e.target.value.length === 1) {
                              focusNextInput("otp4");
                            }
                          }}
                        />
                      </div>
                      <ErrorMessage name="otp4" component="div" className=" text-left ml-2 text-red-500 text-sm mt-1" />
                    </div>    
                </div>
                <button type="submit" className="bg-[#ff6f61] text-white py-2 mb-4 mt-4 px-4 font-medium rounded">
                  {loadingSend ? (
                    <div className="flex items-center">
                      <div
                        className="spinner"
                        style={{
                          border: '2px solid rgba(255, 255, 255, 0.3)',
                          borderRadius: '50%',
                          borderTop: '2px solid #fff',
                          width: '20px',
                          height: '20px',
                          animation: 'spin 1s linear infinite',
                          marginRight: '10px',
                        }}
                      />
                      Verifying...
                    </div>
                  ) : (
                    'Send'
                  )}
                </button>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    );
  };

  const reSendOtp = async (value) => {
    try {
      const data = {
        email: value
      };
      const response = await axios.post(
        "https://bankdata.inclineanalytics.com/api/users/resend_otp",
        data
      );
      if (response.data.success) {
        toast.success(response.data.message);
      }
    } catch (error) {
      console.error("Error re-send otp:", error);
      toast.error(error.response.data.message);
    }
  };

  const loginUser=async(values)=>{
    setEmail(values.email)
    try {
        setLoading(true)
        const userData = {
          email: values.email,
          password:values.password,
          } 
        const response = await axios.post(
          "https://bankdata.inclineanalytics.com/api/users/login",
         userData
        );
        if(response.data.success){
          const data = response.data.data;
          const {userRole} = data
          if(userRole==="BASIC"){
            toast.success(response.data.message)
            localStorage.setItem("role",response.data.data.userRole)
            Cookies.set('jwt_token', response.data.data.token, { expires: 30,secure:true});
            setTimeout(()=>{
              navigate('/user')
              setLoading(false)
            },2000) } 
          else{
            console.error("Invalid Credentials");
            toast.error("Invalid Credentials, Try again");
            setLoading(false)
        }
        }
      } catch (error) {
        if(error.response.data.data.active===false){
          setShowPopupVerify(true)
          reSendOtp(values.email)
        }
        console.error("Error login user:", error);
        toast.error(error.response.data.message)
        setLoading(false)
      }finally{
        setLoading(false)
      }
  }
  const onSubmit = (values, { setSubmitting }) => {
    setSubmitting(false);
    loginUser(values)
  };

  const updateViewPassword=()=>{
    setViewPassword(!viewPassword)
  }

  const handleCancel = () => {
    setShowPopupVerify(false);
  };

  return (
    <div className ="bg-[#001f3f] max-h-[100vh] h-screen overflow-y-auto p-2 text-[#fff]">
      <ToastContainer/>
      <div className="flex flex-col justify-center items-center">
        <div>
            <a href="/" className="inline-block">
                <img src="https://www.inclineanalytics.com/wp-content/uploads/2020/04/Incline-Analytics5-01.png" alt="Incline Analytics Logo" style={{ width: "150px", height: "auto" }} />
            </a>
        </div>
        <div className="lg:space-x-16 mt-5 lg:mt-0 h-[80vh] flex flex-col lg:flex-row lg:justify-center lg:items-center">
            <div className="lg:w-1/2 -mt-10 mb-5">
                <h1 className='font-bold text-5xl leading-tight'>
                Leverage your data <br />
                <span className='text-[#ff6f61]'>elevate&nbsp;your business</span>
                </h1>
                <p className='text-lg leading-normal mt-5' style={{ fontSize: "18px", lineHeight: "1.5", marginTop: "20px" }}>
                We specialize in advanced analytics tailored for multi-site healthcare companies. We equip our clients with insights and tools to stimulate revenue growth, improve operational efficiencies, streamline cost management, and fortify managerial controls for scalable operations. Through customized analytics solutions, we offer valuable insights that support strategic decision-making, optimize overall performance, and fortify investor relations.
                </p>
            </div>
            <div className="lg:w-1/2">
                <div className="max-w-md mx-auto">
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={onSubmit}
                    >
                        {({isSubmitting }) => (
                        <Form className="bg-white p-8 rounded-lg shadow-md">
                            {/* <h1 className="text-[#ff6f61] text-3xl font-bold mb-2">Login</h1> */}
                            <div className="mb-4 h-[100px] min-w-[200px]">
                            <label htmlFor="email" className="block text-left text-gray-700 text-lg font-bold mb-2">
                                Email
                            </label>
                            <Field
                                type="email"
                                id="email"
                                name="email"
                                className="mt-1 block w-full p-2 pl-4 border rounded-lg text-black border-[#ff6f61] focus:border-[#ff6f61] focus:border-[3px] focus:outline-none"
                            />
                            <ErrorMessage name="email" component="div" className=" text-left ml-2 text-red-500 text-sm mt-1" />
                            </div>

                            <div className="mb-4 h-[100px] min-w-[200px]">
                            <label htmlFor="password" className="block text-left text-gray-700 text-lg font-bold mb-2">
                                Password
                            </label>
                            <div className="mt-1 w-full flex p-2 pl-4 border rounded-lg text-black border-[#ff6f61] focus-within:border-[3px]">
                            <Field
                                type={`${viewPassword? 'text':'password'}`}
                                id="password"
                                name="password"
                                className="text-black w-full focus:outline-none"
                            />
                            <button type='button' className="text-black mr-2 text-xl" onClick={updateViewPassword}>{viewPassword? <FaEye />:<FaEyeSlash />}</button>
                            </div>
                            <ErrorMessage name="password" component="div" className="text-left ml-2 text-red-500 text-sm mt-1" />
                            </div>

                            <button
                            type="submit"
                            className="w-full bg-[#ff6f61] mt-4 text-white py-2 px-4 rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                            disabled={isSubmitting}
                            >
                            {loading? 
                              <div className="flex justify-center items-center">
                                <div className="spinner" style={{
                                  border: "2px solid rgba(255, 255, 255, 0.3)",
                                  borderRadius: "50%",
                                  borderTop: "2px solid #fff",
                                  width: "20px",
                                  height: "20px",
                                  animation: "spin 1s linear infinite",
                                  marginRight: "10px"
                                }} />
                                Logging in...
                              </div>:"Login"}
                            </button>
                            <div className="flex justify-end items-center ">
                            
                            <button type="button" onClick={()=>{
                              navigate('/forgot-password')
                            }} className="block text-blue-900 hover:underline mt-5 text-right">Forgotten password?</button>
                            
                            </div><hr className="border border-gray-300 mt-4"/>
                            <h1 className="text-gray-700 inline mr-4">Don't have an account?</h1>
                            <button type='button' onClick={()=>{
                                navigate('/create-new-user')
                            }} className="bg-[#ff6f61] p-2 mt-4 rounded-lg">Create account</button>
                        </Form>
                        )}
                    </Formik>
                </div>
            </div>
        </div>
        {showPopUpVerify && (
        <Popup
          onCancel={handleCancel}
          emailId={email}
          />
      )}
      </div>
    </div>
  );
};

export default Home;
